export const authScreens = {
  accesoDirecto: {
    loading: "Entrando a la cuenta…",
  },
  confirmar: {
    verifying: "Verificando cuenta ... ",
    verifiedSuccess: "Cuenta verificada con éxito",
    tokenInvalid: "Token no existe o ya expiro",
    backHome: "Regresar al Home",
  },
  recovery: {
    title: "Recuperar contraseña",
    successTitle: "¡Éxito!",
    successDesc:
      "Tu contraseña fue cambiada correctamente. Te redirigimos al inicio…",
    infoTitle: "Crea una nueva contraseña",
    infoDesc:
      "Al cambiarla, se cerrarán todas las sesiones activas en otros dispositivos.",
    newPasswordLabel: "Nueva contraseña",
    newPasswordPlaceholder: "Escribe tu nueva contraseña",
    togglePasswordAria: "Mostrar/ocultar contraseña",
    confirmPasswordLabel: "Repetir contraseña",
    confirmPasswordPlaceholder: "Repite tu nueva contraseña",
    passwordsMismatch: "Las contraseñas no coinciden.",
    submit: "Cambiar contraseña",
    submitting: "Procesando…",
    backToStart: "Volver al inicio",
    footerWeb: "Web",
    toastInvalidLink: "El enlace de recuperación no es válido o ha expirado.",
    errorGeneric: "No fue posible cambiar la contraseña.",
  },
};
